<!--
 * @Description: 体能动态
 * @Author: Zhang Xin (1483812724@qq.com)
 * @Date: 2023-08-23 10:10:44
 * @LastEditors: Wang Xiaowu (wangxiaowu@example.com)
 * @LastEditTime: 2023-11-16 08:55:09
 -->
<template>
  <div class="physicalFitness">
    <div class="eacharts">
      <echarts :chart-id="'physicalFitness'" :chart-option="options"></echarts>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    heartRateStatistics: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      options: {
        backgroundColor: "#fff",
        color: ["#B1DE58"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          formatter: function (x) {
            let date = x[0].data.year
            let shenshui = parseInt(x[0].data.在床 / 60) + '时' + (x[0].data.在床 % 60) + '分'
            let ss = '<div>' + '在床：' + shenshui + '</div>'
            let ddv = date + ss
            return ddv
            // return ddv
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#7D7D7D", // x轴的颜色
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              color: "#393939", // X轴文字颜色
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
            lineStyle: {
              color: "#eeeeee",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#393939",
            fontSize: 14,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#e7e9ef",
              type: "dashed",
            },
          },
        },
        dataset: {
          dimensions: ["year", "在床"],
          source: [],
        },
        series: [
          {
            type: "bar",
            stack: "总量",
            barMaxWidth: 20,
            label: {
              show: false,
              position: "inside",
            },
          },
          // {
          //   type: "bar",
          //   stack: "总量",
          //   barMaxWidth: 20,
          //   label: {
          //     show: false,
          //     position: "inside",
          //   },
          // },
        ],
      },
    };
  },
  created() {
    let data = []
    let sss = { ...this.options }
    sss.dataset.source = [];
    this.heartRateStatistics.forEach((item) => {
      data = {
        year: item.sleepDate,
        在床: item.abedDuration
        // 中睡: item.moderateSleep
        //   ? Number(item.moderateSleep.slice(0, 2) * 60) +
        //     Number(item.moderateSleep.slice(3, 5))
        //   : "0",
        // 浅睡: item.lightSleep
        //   ? Number(item.lightSleep.slice(0, 2) * 60) +
        //     Number(item.lightSleep.slice(3, 5))
        //   : "0",
        // 清醒: item.sober
        //   ? Number(item.sober.slice(0, 2) * 60) + Number(item.sober.slice(3, 5))
        //   : "0",
      };
      sss.dataset.source.push(data)
    });
    this.options = { ...sss };
  },
  watch: {
    heartRateStatistics: {
      handler(newVal, oldVal) {
        if (newVal) {
          let data = [];
          this.heartRateStatistics = newVal;
          let sss = { ...this.options };
          sss.dataset.source = [];
          this.heartRateStatistics.forEach((item) => {
            data = {
              year: item.sleepDate,
              在床: item.abedDuration
              // 中睡: item.moderateSleep
              //   ? Number(item.moderateSleep.slice(0, 2) * 60) +
              //     Number(item.moderateSleep.slice(3, 5))
              //   : "0",
              // 浅睡: item.lightSleep
              //   ? Number(item.lightSleep.slice(0, 2) * 60) +
              //     Number(item.lightSleep.slice(3, 5))
              //   : "0",
              // 清醒: item.sober
              //   ? Number(item.sober.slice(0, 2) * 60) +
              //     Number(item.sober.slice(3, 5))
              //   : "0",
            };
            sss.dataset.source.push(data);
          });
          this.options = { ...sss };
        } else {
          this.sleepData = oldVal;
        }
      },
      deep: true,
      // immediate: true
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.physicalFitness {
  // width: 100%;
  .eacharts {
    // width: 100%;
    height: 200px;
  }
}
</style>